import { FC } from 'react'

import { ShippingLineSelection } from 'components/molecules/ShippingLineSelection'

export interface TabSmartSendProps {
  className?: string | undefined
  shipment: any
  searchForSavedQuotes: any
  selectedOrderId?: any
  notify?: any
  callOrderShipmentsById?: any
  setMainLoadingState?: any
}

export const TabSmartSend: FC<TabSmartSendProps> = ({
  className,
  shipment,
  searchForSavedQuotes,
  selectedOrderId,
  notify,
  callOrderShipmentsById,
  setMainLoadingState,
}: TabSmartSendProps) => {
  return (
    <div className='w-full pt-6 border-t border-t-N-200'>
      {shipment.shipmentConsignmentQuotes &&
        shipment.shipmentConsignmentQuotes.length > 0 &&
        shipment.shipmentConsignmentQuotes.map((quote: any, index: any) => {
          const obj = {
            type: quote.type,
            productName: quote.productName,
            shipmentId: shipment.id,
            productId: quote.productId,
            cost: quote.cost,
            originCharges: [
              {
                type: 'Discount',
                price: quote.discount,
              },
              {
                type: 'Total Discount',
                price: quote.totalDiscount,
              },
              {
                type: 'Total Transport Assurance',
                price: quote.totalTransportAssurance,
              },
              {
                type: 'Total GST',
                price: quote.totalGST,
              },
              {
                type: 'Total Price',
                price: quote.totalPrice,
              },
            ],
            SameDayPickup: quote.sameDayPickupAvailable,
            SameDayPickupCutOffTime: quote.sameDayPickupCutOffTime,
            TransitDescription: quote.transitDescription,
          }
          if (quote.type === 'SMART/SEND') {
            return (
              <ShippingLineSelection
                key={index}
                isViewOnly={
                  shipment?.status === 'CLOSED' ||
                  shipment?.status === 'CANCELLED'
                }
                ShippingLineObject={obj}
                selectedOrderId={selectedOrderId}
                dateWanted={shipment?.dateWanted}
                notify={notify}
                callOrderShipmentsById={callOrderShipmentsById}
                setMainLoadingState={setMainLoadingState}
              />
            )
          }
        })}
      {shipment.shipmentConsignmentQuotes &&
        searchForSavedQuotes(shipment.shipmentConsignmentQuotes, 'SMART/SEND')}
    </div>
  )
}

TabSmartSend.defaultProps = {
  className: undefined,
}

export default TabSmartSend
